import styled from 'styled-components';

export const ActionBarStyled = styled.div`
  padding: 8px 16px ;

`